import { ActivatedRoute, Router } from '@angular/router';
import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  inject,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { CommonComponent } from '@components/abstract/common-component.component';
import { IMigFormService } from '../../services/mig-form.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  template: '',
})
export abstract class CommonMigFormComponent
  extends CommonComponent
  implements AfterViewChecked
{
  module = inject(IMigFormService);
  router = inject(Router);
  route = inject(ActivatedRoute);
  protected toastr: ToastrService = inject(ToastrService);

  detector = inject(ChangeDetectorRef);
  protected builder = inject(UntypedFormBuilder);
  group: UntypedFormGroup;
  submit = false;

  protected constructor() {
    super();
  }

  ngAfterViewChecked(): void {
    this.detector.detectChanges();
  }

  validate(name: string): string {
    if (!this.submit) return '';
    return this.group.controls[name].errors ? 'is-invalid' : 'is-valid';
  }
}
